import Spline from '@splinetool/react-spline';

export function Earth() {
  return (
      <Spline scene="https://prod.spline.design/1wQyxo4CleDPMbwS/scene.splinecode" />
  );
}
